import { isImageUrl } from "../../utils/ImageUrl";
import { usePublicSiteData } from "./PublicSiteContext";
import PublicSectionTitle from "./PublicSectionTitle";
import { StageImage, useStage } from "./StagedImageLoading";

const PublicStats = () => {
  const website = usePublicSiteData();
  const stats = website?.stats ?? [];
  const statImageCount = stats
    .slice(0, 4)
    .filter((s) => s.icon && isImageUrl(s.icon)).length;
  useStage("stats", statImageCount);

  return (
    <section className="psite-stats-section">
      <div className="psite-section__inner">
        <PublicSectionTitle
          light
          title="Why Clients Choose Us"
          description="Trusted care, measurable results."
        />
        {stats.length > 0 ? (
          <div className="psite-stats-grid">
            {stats.slice(0, 4).map((stat, i) => (
              <div className="psite-stat-card" key={`${stat.label}-${i}`}>
                {stat.icon && (
                  <span className="psite-stat-card__icon">
                    {isImageUrl(stat.icon) ? (
                      <StageImage stage="stats" src={stat.icon} alt="" />
                    ) : (
                      stat.icon
                    )}
                  </span>
                )}
                <span className="psite-stat-card__value">{stat.value}</span>
                <span className="psite-stat-card__label">{stat.label}</span>
              </div>
            ))}
          </div>
        ) : (
          <p className="psite-section__empty psite-section__empty--light">
            Statistics will appear here once published.
          </p>
        )}
      </div>
    </section>
  );
};

export default PublicStats;